(() => {
  if (
    !window.swinger
    || !window.swinger.config
    || !window.swinger.config.maxmind
    || !window.swinger.config.maxmind.id
  ) {
    return;
  }

  window.swinger.observer.initialize('.swinger-registration', () => {
    window.__mmapiws = window.__mmapiws || {};
    window.__mmapiws.accountId = window.__mmapiws.accountId || `${window.swinger.config.maxmind.id}`;
    window.swinger.resourceLoader.script('https://device.maxmind.com/js/device.js');
  });
})();
